import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Products } from '../../../components/PriceOverviewCard/components/Products/index.js';
import { DEFAULT_LOCALE } from '../../../components/PriceOverviewCard/models.js';
import { Flex, LabelMediumBold } from '../../../primitives/index.js';
export const TripSafetyInfo = ({
  products,
  locale = DEFAULT_LOCALE
}) => {
  const {
    t
  } = useTranslation();
  if (!products) {
    return null;
  }
  return _jsxs(Flex, {
    gap: "global/medium",
    children: [_jsx(LabelMediumBold, {
      children: t('priceOverviewCard:tripSafety')
    }), products && _jsx(Products, {
      products: products,
      locale: locale
    })]
  });
};